module.exports = __webpack_public_path__ + "img/bounty_hunter.53b68c6b.png";